import { warn as r } from "./highrise981.mjs";
class i {
  constructor() {
    this.elementZIndex = /* @__PURE__ */ new Map(), this.nextZIndex = 2e3;
  }
  get elementCount() {
    return this.elementZIndex.size;
  }
  ensureZIndex(e, t) {
    const { elementZIndex: n } = this;
    if (t !== void 0) {
      e.style.zIndex = `${t}`, n.delete(e);
      return;
    }
    const { nextZIndex: s } = this;
    n.has(e) && n.get(e) + 1 === this.nextZIndex || (e.style.zIndex = `${s}`, n.set(e, s), this.nextZIndex = s + 1, this.squashState());
  }
  unregister(e, t) {
    const { elementZIndex: n } = this;
    n.has(e) ? n.delete(e) : t === void 0 && r("z-index-manager/unregister-element", "Element not found when unregistering."), this.squashState();
  }
  squashState() {
    const { elementCount: e } = this;
    e || (this.nextZIndex = 2e3), this.nextZIndex - e > 2500 && this.rearrange();
  }
  rearrange() {
    const e = Array.from(this.elementZIndex.entries());
    e.sort((t, n) => t[1] - n[1]), this.nextZIndex = 2e3, e.forEach((t) => {
      const n = t[0], s = this.nextZIndex++;
      `${s}` !== n.style.zIndex && (n.style.zIndex = `${s}`);
    });
  }
}
const h = new i();
export {
  h as default
};
